function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _objectSpread({}, props, {
        version: "1.1",
        id: "Capa_1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 155.139 155.139",
        children: [
            /*#__PURE__*/ _jsx("g", {
                children: /*#__PURE__*/ _jsx("path", {
                    id: "f_1_",
                    d: "M89.584,155.139V84.378h23.742l3.562-27.585H89.584V39.184 c0-7.984,2.208-13.425,13.67-13.425l14.595-0.006V1.08C115.325,0.752,106.661,0,96.577,0C75.52,0,61.104,12.853,61.104,36.452 v20.341H37.29v27.585h23.814v70.761H89.584z"
                })
            }),
            /*#__PURE__*/ _jsx("g", {}),
            /*#__PURE__*/ _jsx("g", {}),
            /*#__PURE__*/ _jsx("g", {}),
            /*#__PURE__*/ _jsx("g", {}),
            /*#__PURE__*/ _jsx("g", {}),
            /*#__PURE__*/ _jsx("g", {}),
            /*#__PURE__*/ _jsx("g", {}),
            /*#__PURE__*/ _jsx("g", {}),
            /*#__PURE__*/ _jsx("g", {}),
            /*#__PURE__*/ _jsx("g", {}),
            /*#__PURE__*/ _jsx("g", {}),
            /*#__PURE__*/ _jsx("g", {}),
            /*#__PURE__*/ _jsx("g", {}),
            /*#__PURE__*/ _jsx("g", {}),
            /*#__PURE__*/ _jsx("g", {})
        ]
    }));
};
export default Icon;
